import { ContentType as ContentTypeEnum, GroupContent, HeaGroupModule, Role, Program, Content as OriginalContent, LessonType, UnitContentFragment, HeaUnitContentFragment, UserFragment as User, HeaPresentationModuleFragment, SllModule, SllGroupModule, SllLessonContentFragment } from 'src/api/graphql-codegen';

export type { HeaUnit, Unit, Program, SpecialProgram, LessonFragment as Lesson, ExtendedUnitFragment as ExtendedUnit, ExtendedHeaUnitFragment as ExtendedHeaUnit, UserFragment as User, ExtendedUserFragment as ExtendedUser, HeToken, HeaUserFragment as HEAUser, SectionFragment, SllLesson, SllModule, SllSection, SllGroupModule } from 'src/api/graphql-codegen';

export { ContentTypeEnum as ContentType, LessonType };

export type Content = Omit<OriginalContent, 'createdBy' | 'created' | 'updated' | '__typename'> & Omit<HeaPresentationModuleFragment, 'createdBy' | 'created' | 'updated' | '__typename' | 'useDefault'> & { __typename?: 'Content' | 'HEAModule' | 'HeaPresentationModuleFragment', useDefault?: boolean | null };
export type ExtendedContent = Omit<Omit<Content, '__typename'> & Omit<GroupContent, '__typename'> & Omit<HeaGroupModule, '__typename' | 'moduleId'> & Omit<HeaPresentationModuleFragment, '__typename' | 'updated'> & { groupName: string, groupId: string, moduleId?: string, parent?: any }, 'created'>;
export type ExtendedSllModule = Omit<SllModule, '__typename'> & Omit<SllGroupModule, '__typename' | 'moduleId'> & { groupName: string, groupId: string, moduleId?: string };

export interface EditSllLesson extends Omit<SllLessonContentFragment, 'id' | 'coverImage' | 'bannerImage' | 'status'> {
  id?: string;
  coverImage?: File | string | null;
  bannerImage?: File | string | null;
}

export interface EditUnit extends Omit<(UnitContentFragment & HeaUnitContentFragment), 'id' | 'coverImage' | 'type' | 'originalUnitId' | '__typename' | 'skill' | 'default' > {
  id?: string;
  coverImage?: File | string | null;
  type?: string;
  skill?: string;
  default?: boolean;
  originalUnitId?: string;
  hea?: boolean;
  alternateMaterials?: Content[];
  __typename?: 'Unit' | 'HEAUnit'
}

export enum UnitTypes {
  School = 'School',
  HomeEd = 'HomeEd'
};

export enum UserRoleEnum {
  SuperAdmin = 'SuperAdmin',
  DistrictAdmin = 'DistrictAdmin',
  Admin = 'Admin',
  User = 'User',
  ContentAdmin = 'ContentAdmin'
}

export type UserRole = Role

export enum UserStatus {
  Pending = 'Pending',
  Accepted = 'Accepted',
  Locked = 'Locked',
}

export enum AccountStatus {
  Active = 'Active',
  Expired = 'Expired',
}

export enum LessonStatus {
  NotStarted = 'not started',
  Completed = 'completed',
  InProgress = 'in progress',
  Confirmed = 'confirmed'
}

export enum SurveyTypes {
  ExitTickets = 'Exit Tickets',
  Research = 'Research',
  PreProgram = 'Pre-Program Quiz',
  StudentQuiz = 'Assessment',
  PostProgram = 'Post-Program Quiz',
  AbsentStudent = 'Absent Student Surveys',
}

export enum ModeTypeEnum {
  Units = 'Preview Lessons',
  Edit = 'Create Study Plans',
  Study = 'Study Mode'
}

export enum MyCourseEnum {
  Library = 'Standalone Lessons',
  Courses = 'My Collections',
}

export enum LessonLibraryEnum {
  Library = 'Lesson Library',
  Programs = 'Programs',
}

export enum MyQuizEnum {
  QuizBuilder = 'Assessment Builder',
  MyQuizzes = 'My Assessments',
}

export enum MyUsageEnum {
  Summary = 'Summary',
  Lessons = 'Student Lessons',
  Educators = 'Educators',
  // ExitTicket = 'Exit Ticket',
  // Quiz = 'Quiz',
}

export enum UsageEnum {
  Usage = 'Usage',
  Engagement = 'Engagement',
}

/*
export type User = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  customer: Customer;
  status: UserStatus;
  expiry: string;
  createdAt: string;
  updatedAt: string;
  schools: Dictionary[];
  subject: string;
  position: Dictionary;
  admin: string;
  firstLoginFormFilled: boolean;
  role: string;
  districtSchools: string;
  usages?: string;
  roleDesc?: string;
}
*/

export type ContentDataPDFType = string;

export type SelectOption = {
  label: string;
  value: string;
  // We have some bad values for lessonCategoryStyle in the DB ('Icebreakers, BrainBreaks, BrainBreak' are belongs into BrainBreak Label.)
  // We have to udpate the style manually at the edit-lesson
  // After DB update, we should remove the oldValues.
  oldValues?: string[];
}

export type Dictionary<T = string> = {
  id: T;
  name: string;
}

export type Customer = {
  id: string;
  name: string;
  expiry?: string;
  courses: Program[];
  trial: boolean;
  country: string;
  state: string;
  city: string;
  dataCollections: Dictionary[];
}

export type Grade = {
  position: number;
} & Dictionary;

export type School = {
  exitTicketCC: string;
  preProgramQuizCC: string;
  status: string;
  groups: Dictionary[];
  dataCollections: Dictionary[];
  courses: {id: string}[];
  disabledPwLogin: boolean;
  isPrimary: boolean;
} & Dictionary;

export type UserFlags = {
  id: string;
  firstLoginFormFilled: boolean;
}

export enum SpecialCourseIconTypeEnum {
  book = 'book',
  study = 'study',
}

export type FeedbackForm = {
  doNotSendToTeacher: boolean;
  instructions: string;
  contentInstruction: string;
  learningOutcomes: string;
  finalCopy: string;
  elements: FeedbackFormElement[];
  surveyType: string;
};

export type FeedbackFormElement = FeedbackFormElementText | FeedbackFormElementSelect | FeedbackFormElementMultiScale;

export type FeedbackFormBase = {
  id: string;
  value: string;
  type: FeedbackFormElementTypeEnum;
  placeholder?: string;
  doNotSendToTeacher?: boolean;
  isSensitive?: boolean;
  askExplanation?: boolean;
  competency?: string;
};

export type FeedbackFormElementText = {
  type: FeedbackFormElementTypeEnum.text | FeedbackFormElementTypeEnum.textarea;
  answer?: {
    value: string;
    answerExplanation?: string;
  }
  lengthLimit?: boolean;
} & FeedbackFormBase;

export type FeedbackFormElementSelect = {
  type: FeedbackFormElementTypeEnum.checkbox | FeedbackFormElementTypeEnum.checkboxAssessable | FeedbackFormElementTypeEnum.radio | FeedbackFormElementTypeEnum.radioAssessable;
  options: string[];
  assessments?: boolean[];
  answer?: {
    value: string[];
    answerExplanation?: string;
  }
} & FeedbackFormBase;

export type FeedbackFormElementMultiScaleStatement = {
  id: string;
  value: string;
  assessment?: string;
}

export type FeedbackFormElementMultiScale = {
  type: FeedbackFormElementTypeEnum.multiScale | FeedbackFormElementTypeEnum.multiScaleAssessable,
  statements: FeedbackFormElementMultiScaleStatement[];
  options: string[];
  answer?: Record<string, string>;
} & FeedbackFormBase;

export enum FeedbackFormElementTypeEnum {
  text = 'text',
  textarea = 'textarea',
  checkbox = 'checkbox',
  checkboxAssessable = 'checkboxAssessable',
  radio = 'radio',
  radioAssessable = 'radioAssessable',
  multiScale = 'multiScale',
  multiScaleAssessable = 'multiScaleAssessable',
}

export type FeedbackFormContent = {
  id: string;
  programName: string;
  lessonName: string;
  unitName?: string;
  createdBy: User;
  expirationAt: string;
  formData: string; // JSON for FeedbackForm
  exitTicketCount?: number;
  link?: string;
}

export type FeedbackFormContentSimple = {
  id: string;
  programName: string;
  lessonName: string;
  createdBy: string;
  expirationAt: string;
  formData: string; // JSON for FeedbackForm
}

export interface FeedbackFormAnswer {
  id: string
  formId: string
  formData: string // JSON for FeedbackForm
  createdAt: string
}

export interface VideoSubtitle {
  name: string
  languageCode: string
  id: string
}

// add Groups type
export type SchoolGroup = {
  id: string;
  name: string;
}

//Add for invite children
export type Children = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  inviteId: string;
  grade: string;
}

export enum InviteTypeEnum {
  Parent = 'Parent',
  Own = 'Own'
}

export enum DefaultModuleEnum {
  Default = 'Default',
  HomeEd = 'HomeEd'
}

export type ModulePositionInput = {
  lessonId: string,
  unitId: string,
  position: number
}

export type MoveLessonInput = {
  lessonId: string,
  unitId: string,
  oldPosition: number,
  newPosition: number
}

export type ExitTicketActive = {
  lessonNum: number,
  formData?: string | null,
  status: boolean,
  type?: number | 0,
  exitTicketCount: number,
  expiryMinutes: number,
  copyLink: string,
  code: string,
};

export type ExtendedQuiz = {
  id: string,
  name: string,
  color?: string | null,
  darkColor?: string | null,
  feedbackForm?: FeedbackFormContent,
  unitIds?: string[],
  expiryMinutes?: number,
  status?: boolean,
};

// types/video-translation.ts
export interface EnglishCaptionJob {
  id: string;
  userId: string;
  videoUrl: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  progressPercentage: number;
  subtitleUrl?: string;
  errorMessage?: string;
  createdAt: string;
  updatedAt: string;
  completedAt?: string;
}

export interface LanguageJob {
  id: string;
  parentJobId: string;
  languageCode: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  subtitleUrl?: string;
  errorMessage?: string;
  retryCount: number;
  maxRetries: number;
  createdAt: string;
  updatedAt: string;
  completedAt?: string;
}

export interface TranslationJob {
  id: string;
  userId: string;
  videoUrl: string;
  targetLanguages: string[];
  status: 'pending' | 'generating_english' | 'processing' | 'completed' | 'failed' | 'partial' | 'cancelled';
  progressPercentage: number;
  translationResults?: any;
  errorMessage?: string;
  externalJobId?: string;
  createdAt: string;
  updatedAt: string;
  completedAt?: string;
  englishSubtitleUrl?: string;
  languageJobs: LanguageJob[];
}

export interface UseVideoTranslationReturn {
  // States
  englishCaptionJob: EnglishCaptionJob | null;
  translationJob: TranslationJob | null;
  loading: boolean;
  error: string | null;
  
  // Actions
  generateEnglishCaptions: (assetId: string) => Promise<void>;
  createTranslationJob: (assetId: string, targetLanguages?: string[]) => Promise<void>;
  stopPolling: () => void;
  reset: () => void;
  stopTranslationJob: () => void;
  downloadFile: (url: string, filename: string) => void;
  downloadEnglishSubtitles: () => void;
  downloadTranslationSubtitles: (languageCode: string) => void;
  
  // Status helpers
  isProcessing: boolean;
  isCompleted: boolean;
  hasError: boolean;
  overallProgress: number;
}

export interface VideoTranslationOptions {
  pollingInterval?: number;
  onEnglishCaptionsComplete?: (job: EnglishCaptionJob) => void;
  onTranslationComplete?: (job: TranslationJob) => void;
  onError?: (error: string) => void;
}

export const TRANSLATION_LANGUAGES = [
  { code: 'AM', name: 'Amharic' },
  { code: 'AR', name: 'Arabic' },
  { code: 'BG', name: 'Bulgarian' },
  { code: 'BN', name: 'Bengali' },
  { code: 'CS', name: 'Czech' },
  { code: 'DA', name: 'Danish' },
  { code: 'DE', name: 'German' },
  { code: 'EL', name: 'Greek' },
  { code: 'EN', name: 'English' },
  { code: 'EN_GB', name: 'English (British)' },
  { code: 'EN_US', name: 'English (American)' },
  { code: 'ES', name: 'Spanish' },
  { code: 'ET', name: 'Estonian' },
  { code: 'FA', name: 'Persian (Farsi)' },
  { code: 'FI', name: 'Finnish' },
  { code: 'FR', name: 'French' },
  { code: 'HE', name: 'Hebrew' },
  { code: 'HMN', name: 'Hmong' },
  { code: 'HI', name: 'Hindi' },
  { code: 'HT', name: 'Haitian' },
  { code: 'HU', name: 'Hungarian' },
  { code: 'ID', name: 'Indonesian' },
  { code: 'IT', name: 'Italian' },
  { code: 'JA', name: 'Japanese' },
  { code: 'KO', name: 'Korean' },
  { code: 'LO', name: 'Lao'},
  { code: 'LT', name: 'Lithuanian' },
  { code: 'LV', name: 'Latvian' },
  { code: 'NB', name: 'Norwegian Bokmål' },
  { code: 'NL', name: 'Dutch' },
  { code: 'NV', name: 'Navajo' },
  { code: 'PA', name: 'Punjabi' },
  { code: 'PL', name: 'Polish' },
  { code: 'PT', name: 'Portuguese' },
  { code: 'PT_BR', name: 'Portuguese (Brazilian)' },
  { code: 'PT_PT', name: 'Portuguese (European)' },
  { code: 'RO', name: 'Romanian' },
  { code: 'RU', name: 'Russian' },
  { code: 'SK', name: 'Slovak' },
  { code: 'SL', name: 'Slovenian' },
  { code: 'SO', name: 'Somali' },
  { code: 'SV', name: 'Swedish' },
  { code: 'SW', name: 'Swahili' },
  { code: 'TA', name: 'Tamil' },
  { code: 'TE', name: 'Telugu' },
  { code: 'TH', name: 'Thai' },
  { code: 'TL', name: 'Tagalog' },
  { code: 'TR', name: 'Turkish' },
  { code: 'UK', name: 'Ukrainian' },
  { code: 'UR', name: 'Urdu' },
  { code: 'VI', name: 'Vietnamese' },
  { code: 'ZH', name: 'Chinese' },
  { code: 'ZH_HANS', name: 'Chinese Simplified' },
  { code: 'ZH_HANT', name: 'Chinese Traditional' }
];